import PortalGuide from "../js/components/portalGuide/PortalGuide.react";
export default PortalGuide;
